<template>
  <RegularCustomer />
</template>

<script>
import RegularCustomer from '@/components/RegularCustomer'

export default {
  components: {
    RegularCustomer
  }
}
</script>

<style></style>
